<template>
        <header :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
                <div class="header-container">
                        <div class="logo" @click="goToTop">
                                <img src="@/assets/images/Logo.svg" alt="menoah" />
                        </div>
                        <div class="download-button" v-if="isTopPage">
                                <button @click="redirectToAppStore">ダウンロード</button>
                        </div>
                </div>
        </header>
</template>

<script>
export default {
        name: 'HeaderComponent',
        data() {
                return {
                        isMobile: false,
                        appStoreUrl: 'https://apps.apple.com/jp/app/id6736600712'
                }
        },
        computed: {
                isTopPage() {
                        return this.$route.path === '/'
                }
        },
        mounted() {
                this.checkScreenSize()
                window.addEventListener('resize', this.checkScreenSize)
        },
        beforeUnmount() {
                window.removeEventListener('resize', this.checkScreenSize)
        },
        methods: {
                checkScreenSize() {
                        this.isMobile = window.innerWidth < 768
                },
                redirectToAppStore() {
                        window.open(this.appStoreUrl, '_blank')
                },
                goToTop() {
                        this.$router.push('/')
                }
        }
};
</script>

<style>
/* 共通スタイル - ヘッダー全体の基本設定 */
header {
        text-align: center;
        background-color: var(--color-white);
        color: var(--color-green-500);
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 1000;
}

/* 共通スタイル - ヘッダーコンテナの配置 */
.header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1120px;
        margin: 0 auto;
        width: 100%;
}

/* モバイル専用スタイル - isMobileがtrueの場合に適用 */
header.mobile {
        padding: 0 24px;
}

header.mobile .header-container {
        width: 100%;
        height: 72px;
        padding: 0 0px;
}

header.mobile .logo img {
        height: 20px;
}

header.mobile .download-button button {
        background-color: var(--color-yellow-500);
        color: var(--color-green-600);
        border: none;
        border-radius: 25px;
        width: 131px;
        height: 41px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
}

/* デスクトップ専用スタイル - isMobileがfalseの場合に適用 */
header.desktop {
        padding: 18px;
}

header.desktop .logo img {
        height: 29px;
}

header.desktop .download-button button {
        background-color: var(--color-yellow-500);
        color: var(--color-green-600);
        border: none;
        border-radius: 25px;
        width: 143px;
        height: 43px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
}
</style>

